import { injectable } from '@theia/core/shared/inversify';
import { BrowserOnlyWorkspaceServer } from '@theia/workspace/lib/browser-only/browser-only-workspace-server';

@injectable()
// Convenience implementation of the WorkspaceServer that does not persist recent workspaces and most recently used workspace.
export class EphemeralWorkspaceServer extends BrowserOnlyWorkspaceServer {
    override async getRecentWorkspaces(): Promise<string[]> {
        return [];
    }

    override async getMostRecentlyUsedWorkspace(): Promise<string | undefined> {
        return undefined;
    }

    override async setMostRecentlyUsedWorkspace(_uri: string): Promise<void> {}

    override async removeRecentWorkspace(_uri: string): Promise<void> {}
}
